import {
	FASTSHIFT_RELATED_TICKET_ISSUE_TYPE,
	FastshiftRelatedTicket,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { FormattedMessage } from 'react-intl';

import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { MigrationTicketsCard } from '@/common/migration-tickets-card';

import { messages } from '../messages';

export type RelatedTicketsExpandedRowProps = {
	relatedTickets: FastshiftRelatedTicket[];
	onClickAnalyticsEvent: (ticketId: string) => void;
};

const expandedRowContainerStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle',
	paddingBlock: 'space.150',
	paddingInline: 'space.400',
});

const relatedTicketsListStyles = xcss({
	backgroundColor: 'color.background.input',
	border: `1px solid ${token('color.border')}`,
	borderRadius: 'radius.small',
});

export const RelatedTicketsExpandedRow = ({
	relatedTickets,
	onClickAnalyticsEvent,
}: RelatedTicketsExpandedRowProps) => (
	<Box xcss={expandedRowContainerStyles}>
		<Stack space="space.150">
			{relatedTickets.length === 0 ? (
				<Text size="small" color="color.text.subtle">
					<FormattedMessage {...messages.migrationTicketsTableNoRelatedTickets} />
				</Text>
			) : (
				<>
					<Text size="small" weight="bold" color="color.text.subtle">
						<FormattedMessage {...messages.migrationTicketsTableRelatedTicketsExpandedTitle} />
					</Text>
					<Stack xcss={relatedTicketsListStyles}>
						{relatedTickets.map((ticket, index) => (
							<MigrationTicketsCard
								key={ticket.supportTicketId}
								issueType={ticket.issueType ?? FASTSHIFT_RELATED_TICKET_ISSUE_TYPE.SUPPORT_REQUEST}
								supportTicketId={ticket.supportTicketId}
								title={ticket.title}
								status={ticket.fastShiftStatusReason}
								showBottomBorder={index !== 0}
								onClickAnalyticsEvent={onClickAnalyticsEvent}
							/>
						))}
					</Stack>
				</>
			)}
		</Stack>
	</Box>
);
